import type { ActionReturn } from 'svelte/action';

export function useClickOutside(node: HTMLElement): ActionReturn {
  const handleClick = (event: MouseEvent) => {
    if (
      node &&
      !node.contains(event.target as Node) &&
      !event.defaultPrevented
    ) {
      node.dispatchEvent(new CustomEvent('clickOutside', { detail: node }));
    }
  };

  const handleKeyUp = (event: KeyboardEvent) => {
    if (event.key === 'Escape')
      node.dispatchEvent(new CustomEvent('clickOutside', { detail: node }));
  };

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keyup', handleKeyUp, true);

  return {
    destroy() {
      document.removeEventListener('click', handleClick, true);
      document.removeEventListener('keyup', handleKeyUp, true);
    },
  };
}
